import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { PageNotFound } from '@parapet/common';
import { Login } from './components/Auth/Login';

const ForgotPassword = lazy(() => import('./components/Auth/ForgotPassword'));
const SetPassword = lazy(() => import('./components/Auth/SetPassword'));

export const AppRoutes: React.FC = () => (
  <Suspense fallback={<>Loading...</>}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/login/?company=:company&callback=:callback"
          element={<Login />}
        />
        <Route path="/logout" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/set-password/:token?" element={<SetPassword />} />
        <Route element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  </Suspense>
);
